import { useEffect } from "react";
import { Table, Switch } from "antd";
import { ColumnsType } from "antd/es/table";
import { creditFlagRender } from "@/utils/utils";
import { useGlobalModel } from "@/model/globalModel";
import { accountDataModel } from "./accountDataModel";
import { IAccountDetail } from "@/views/account/AccountTypes";
import YhTootip from "@/components/YhTootip";

export function AccountDataTable() {

    const { appDs } = useGlobalModel();
    const {
        loading, dataSource, selectedRowKeys,
        onSearch, setSelectedRowKeys, setSelectedData,
    } = accountDataModel();

    const columns: ColumnsType<IAccountDetail> = [
        {
            align: "center",
            title: '分支',
            dataIndex: 'branch',
            width: 80,
            render: (v) => {
                let item = appDs?.find(item => item.value === v)
                return item?.label
            }
        },
        {
            align: "center",
            title: '账户编码',
            dataIndex: 'code',
            width: 120,
            render: (text, recode) => <YhTootip text={text} />
        },
        {
            align: "center",
            title: '账户名称',
            dataIndex: 'name',
            width: 400,
            render: (text, recode) => <YhTootip text={text} />
        },
        {
            align: "center",
            title: '授信类型',
            dataIndex: 'creditFlag',
            width: 120,
            render: (text, recode) => <YhTootip text={creditFlagRender(text)} />
        },
        {
            align: "center",
            title: '账户类型',
            dataIndex: 'accountTypeName',
            width: 120,
            render: (text, recode) => <YhTootip text={text} />
        },
        {
            align: "center",
            title: '账户实体',
            dataIndex: 'beName',
            width: 300,
            render: (text, recode) => <YhTootip text={text} />
        },
        {
            align: "center",
            title: '从属机构',
            dataIndex: 'orgName',
            width: 120,
        },
        {
            align: "center",
            title: '授信额度',
            dataIndex: 'creditAmount',
            width: 120,
        },
        {
            align: "center",
            title: '已用额度',
            dataIndex: 'usedAmount',
            width: 120,
        },
        {
            align: "center",
            title: '可用额度',
            dataIndex: 'availableAmount',
            width: 120,
        },
        {
            align: "center",
            title: '剩余金额',
            dataIndex: 'remainingAmount',
            width: 120,
        },
        {
            align: "center",
            title: '创建日期',
            dataIndex: 'createTime',
            width: 200,
        },
        {
            align: "center",
            title: '备注',
            dataIndex: 'note',
        },
    ];

    useEffect(() => {
        onSearch();
    }, [])

    return (
        <Table
            loading={loading}
            rowKey={record => record.key}
            columns={columns}
            dataSource={dataSource}
            rowSelection={{
                type: "radio",
                selectedRowKeys: selectedRowKeys, //记录选中
                onChange: (selectedRowKeys: React.Key[], selectedRows: IAccountDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys as string[]);
                    setSelectedData(selectedRows);
                }
            }}
            pagination={false}
            scroll={{ x: '2500px', y: "calc(100vh - 446px)" }}
        />
    )
}

